import React, { useEffect, useState } from 'react';
export function OfertaSection() {
  const [viewerCount, setViewerCount] = useState(112);
  useEffect(() => {
    const interval = setInterval(() => {
      setViewerCount(Math.floor(Math.random() * (120 - 95) + 95));
    }, 2500);
    return () => clearInterval(interval);
  }, []);
  return <section className="oferta-section" data-id="element-10">
      <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1772541445/image_z6g9yr.webp" className="oferta-img" alt="Pack Biohacking + 6 bonos" data-id="element-11" />

      <div className="price-card" data-id="element-12">
        <div className="label" data-id="element-13">
          Valor total de los 6 bonos + Biohacking + 800 recetas
        </div>
        <div className="old-price text-[#FF2200]" data-id="element-14">148,65€</div>
        <div className="new-price" data-id="element-15">12,95€</div>
        <div className="save" data-id="element-16">Ahorras 135,70€</div>
      </div>

      <div className="social-proof" data-id="element-17">
        <span className="dot green" data-id="element-18"></span>
        <span data-id="element-19">
          <strong data-id="element-20">{viewerCount}</strong> personas están viendo esta oferta ahora
          mismo
        </span>
      </div>

      <div className="social-proof" data-id="element-21">
        <span className="dot red" data-id="element-22"></span>
        <span data-id="element-23">Últimos 5 cupos disponibles</span>
      </div>

      <a href="https://infoliar.com/cart/56888491966796:1" className="cta-btn" style={{
      textDecoration: 'none',
      display: 'block',
      textAlign: 'center'
    }} data-id="element-24">
        EQUILIBRA TUS HORMONAS YA!
      </a>
    </section>;
}